import { AdminComponent } from '~/components/admin-component/admin-component';

export const InvolvementTypes = () => (
  <AdminComponent
    componentName="InvolvementTypes"
    title="Involvement Types"
  />
);
